var $body = $("body");
var $cartToggle = $(".cart");
var $cartContainer = $("header").find("#cart-container");
var $addToCart = $(".add-to-cart");
var $addToCartQuantity = $(".add-to-cart-quantity");

var $accordionToggle = $("#accordionDelivery .card .card-header").find(
  ".toggle"
);
var $radioButtonCheck = $accordionToggle.find(".radio-button > .radio-inner");
$accordionToggle.on("click", function () {
  "use strict";
  var $radioButton = $(this).find(".radio-inner");
  $radioButtonCheck.removeClass("checked");
  if ($radioButtonCheck.hasClass("checked")) {
    $radioButtonCheck.removeClass("checked");
  } else {
    $radioButton.addClass("checked");
  }
});

var $accordionPaymentToggle = $("#accordionPayment .card .card-header").find(
  ".toggle"
);
var $radioButtonCheckPayment = $accordionPaymentToggle.find(
  ".radio-button > .radio-inner"
);
$accordionPaymentToggle.on("click", function () {
  "use strict";
  var $radioButton = $(this).find(".radio-inner");
  $radioButtonCheckPayment.removeClass("checked");
  if ($radioButtonCheckPayment.hasClass("checked")) {
    $radioButtonCheckPayment.removeClass("checked");
  } else {
    $radioButton.addClass("checked");
  }
});

var $paymentToggle = $("#checkout").find(".payment-toggle");
var $paymentContainer = $("#checkout").find("#order-details");
$paymentToggle.on("click", function () {
  $(this).toggleClass("toggle");
  $paymentContainer.toggleClass("expanded");
  $body.toggleClass("overflow-hidden");
});

(function () {
  "use strict";
  window.addEventListener(
    "load",
    function () {
      var forms = document.getElementsByClassName("needs-validation");
      var validation = Array.prototype.filter.call(forms, function (form) {
        form.addEventListener(
          "submit",
          function (event) {
            if (form.checkValidity() === false) {
              event.preventDefault();
              event.stopPropagation();
              $(form).addClass("has-errors");
            } else {
              $(form).removeClass("has-errors");
              $(form).addClass("submitting");
              $(".list-loader").show();
            }
            form.classList.add("was-validated");
          },
          false
        );
      });
    },
    false
  );
})();

var Cart = function (container, type) {
  this._body = $("body");
  this._addButton = $(".add-to-cart-button");
  this._addQuantityInput = $(".add-to-cart-quantity");
  this._addOptions = $(".product-options");
  this._cartContainer = container;
  this._type = type;
  this.initialize();
};
Cart.prototype = {
  _body: null,
  _addButton: null,
  _addOptions: null,
  _addQuantityInput: null,
  _changeTimeout: null,
  _changeRequest: null,
  _cartContainer: null,
  _type: null,
  _adding: false,
  initialize: function () {
    var self = this;

    this._addButton.on("click", function () {
      if (self._adding) {
        return false;
      }
      var cartError = $(".cart-error");
      cartError.prop("hidden", true).removeClass("show");
      var options = [];
      $(".list-loader").show();

      if (self._addOptions.length > 0) {
        var valid = true;
        self._addOptions.each(function () {
          if ($(this).find("input:checked").val() != null) {
            options.push($(this).find("input:checked").val());
          } else if ($(this).find("input.current-size").length > 0) {
            options.push($(this).find("input.current-size").val());
          } else {
            $(this).addClass("error");
            valid = false;
          }
        });

        if (!valid) {
          $(".list-loader").hide();
          return false;
        }
      }

      self._adding = true;
      self._addButton.prop("disabled", true).attr("aria-disabled", "true");

      function showError(message) {
        cartError
          .text(message || cartError.data("default-message"))
          .prop("hidden", false)
          .addClass("show");
        $(".list-loader").hide();
        self._adding = false;
        self._addButton.prop("disabled", false).removeAttr("aria-disabled");
      }

      $.ajax({
        url: "/cart/add",
        method: "POST",
        dataType: "text",
        data: {
          id: $(this).data("id"),
          qty:
            self._addQuantityInput.length == 0 ? 1 : self._addQuantityInput.val(),
          options: options.length ? options : undefined,
          max_order_amount: 1,
        },
      })
        .done(function (checkoutUrl) {
          checkoutUrl = $.trim(checkoutUrl);
          // Only navigate to a checkout URL on this site.
          var destination = document.createElement("a");
          destination.href = checkoutUrl;
          if (!checkoutUrl || /[\s<>]/.test(checkoutUrl) ||
              destination.host !== window.location.host ||
              destination.protocol !== window.location.protocol) {
            showError();
            return;
          }
          window.location.href = destination.href;
        })
        .fail(function (xhr) {
          var contentType = xhr.getResponseHeader("Content-Type") || "";
          showError(contentType.indexOf("text/plain") === 0 ? xhr.responseText : null);
        });

      return false;
    });

    self._body.find(".side-cart-overlay").on("click", function () {
      self._body.removeClass("overlay");
      self._cartContainer.removeClass("show");
    });
  },
};

new Cart($(".side-cart-placeholder"), "");

getStatus();

function getStatus() {
  $.get("/cart/status", function (response) {
    var data = JSON.parse(response);

    $(".icon-cart-full .count")
      .show()
      .html(data.cart > 0 ? data.cart : "");
  });
}

var Checkout = function (container, type) {
  this.initialize();

  var checkoutValue = $(".checkout-summary-placeholder").data("price");
  var cartContents = [];
  $(".order-products-list .product").each(function () {
    cartContents.push({
      item_id: $(this).data("productcode"),
      item_name: $(this).data("title"),
      discount: $(this).data("discount"),
      price: $(this).data("price"),
      quantity: $(this).data("quantity"),
    });
  });
};
Checkout.prototype = {
  initialize: function () {
    var self = this;

    $(".order-products-list").on("click", ".remove-checkout-product", function () {
      if (self.removing) {
        return;
      }
      var product = $(this).closest(".product");
      var options = product.attr("data-options");
      var error = $(".checkout-cart-error");
      error.prop("hidden", true);
      self.removing = true;
      $(".remove-checkout-product, .checkout-form button[type=submit]").prop("disabled", true);

      function finish() {
        self.removing = false;
        $(".remove-checkout-product, .checkout-form button[type=submit]").prop("disabled", false);
      }

      $.ajax({
        url: "/cart/remove",
        method: "POST",
        dataType: "json",
        data: {
          id: product.data("id"),
          options: options ? options.split(";") : undefined,
        },
      }).done(function (data) {
        product.remove();
        if (data.cart_items === 0) {
          window.location.href = $(".order-products-list").data("empty-url");
          return;
        }
        getStatus();
        $.get("/cart/checkout-summary")
          .done(function (html) { self.applySummary(html); })
          .fail(function () {
            error.text(error.data("default-message")).prop("hidden", false);
          })
          .always(finish);
      }).fail(function (xhr) {
        error.text((xhr.responseJSON && xhr.responseJSON.error) || error.data("default-message")).prop("hidden", false);
        finish();
      });
    });

    $(".form-check-input.payment-input").prop("checked", true);

    $("#billing_country_id").on("change", function () {
      if ($(this).val() === "869dd468-988c-4744-b95d-4a3bc58d559f") {
        $(".form-check-label .cash-on-delivery").removeAttr("disabled");
        $(".payment-country-info").hide();
      } else {
        $(".form-check-label .cash-on-delivery").attr("disabled", "disabled");
        $(".payment-country-info").show();
        if ($(".form-check-input.cash-on-delivery").is(":checked")) {
          $(".form-check-input.cash-on-delivery").prop("checked", false);
        }
      }

      if ($("#delivery-checkbox").is(":checked")) {
        return;
      }
      self.changeDeliveryCountry();
    });

    $("#delivery input, #payment input").on("change", function () {
      self.saveDeliveryChoice(
        $("input[name=payment_type_id]:checked").val(),
        $("input[name=delivery_type_id]:checked").val(),
        $("select[name=billing_country_id]").val()
      );
    });

    self.changeDeliveryCountry();
    if ($("#delivery-checkbox").is(":checked")) {
      $(".delivery-address").show().find("input").prop("required", true);
    }

    $.get("/cart/checkout-summary", function (html) {
      self.applySummary(html);
    });
  },
  changeDeliveryCountry: function () {
    var country = $("#billing_country_id");
    if ($("#delivery-checkbox").is(":checked")) {
      country = $("#delivery_country_id");
    }
    var countryId = country.val();

    this.saveDeliveryChoice(
      $("input[name=payment_type_id]:checked").val(),
      $("input[name=delivery_type_id]:checked").val(),
      countryId
    );
  },
  saveDeliveryChoice: function (payment, delivery, country) {
    var self = this;
    $.post(
      "/cart/checkout-delivery",
      {
        payment_type_id: payment != null ? payment : null,
        delivery_type_id: delivery != null ? delivery : null,
        country_id: country != null ? country : null,
      },
      function (html) {
        self.applySummary(html);
      }
    );
  },
  applySummary: function (html) {
    var self = this;
    $(".checkout-summary-placeholder").html(html);

    if (!self.executed) {
      self.executed = true;
      var contentIds = [];
      var contents = [];
      $("#order-details .product").each(function () {
        contentIds.push($(this).data("productcode"));
        contents.push({
          id: $(this).data("productcode"),
          quantity: $(this).data("quantity"),
        });
      });
    }
  },
};

if ($("#checkout").length > 0) {
  new Checkout();
}
